import React from 'react'
import styled from 'styled-components'
import { Button } from '../../atoms/Button'
import { GAuseOpenSocial, MenuLink, icons, size } from './platform'

const BottomBlock = styled.div`
  display: flex;
  margin-top: 8px;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  @media only screen and (min-width: ${size.md}) {
    display: none;
  }
`
const Social = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

export const MobileMenuFooter = () => (
  <BottomBlock>
    <Button.NewOutline href="/b2b_signup" size="large" type="link" width="100%">
      Регистрация для b2b клиентов
    </Button.NewOutline>

    <Social>
      <MenuLink
        href="https://www.facebook.com/youtalk.therapy/"
        onClick={GAuseOpenSocial('facebook')}
        rel="noreferrer"
        target="_blank"
      >
        <icons.FacebookIcon />
      </MenuLink>
      <MenuLink
        href="https://www.instagram.com/youtalk.therapy/"
        onClick={GAuseOpenSocial('instagram')}
        rel="noreferrer"
        target="_blank"
      >
        <icons.InstagramIcon />
      </MenuLink>
      <MenuLink
        href="https://vk.com/youtalk.therapy"
        onClick={GAuseOpenSocial('vk')}
        rel="noreferrer"
        target="_blank"
      >
        <icons.VkIcon />
      </MenuLink>
      <MenuLink
        href="https://t.me/youtalktherapy"
        onClick={GAuseOpenSocial('telegram')}
        rel="noreferrer"
        target="_blank"
      >
        <icons.TelegramIcon />
      </MenuLink>
    </Social>
  </BottomBlock>
)
